import { Box } from "@mui/material";
import ProductOfferForm from "pages/products/offers/OfferForm";
import ProductOfferList from "pages/products/offers/OfferList";
import React, { useEffect } from "react";

const ProductOffer = ({ product, fullGrid = false, completed = null }) => {
  useEffect(() => {
    console.log("Pr", product);
  }, [product]);
  return (
    <Box padding={2}>
      <ProductOfferList product_id={product.id} />
      <ProductOfferForm fullGrid={fullGrid} product_id={product.id} />
    </Box>
  );
};

export default ProductOffer;
